@file:OptIn(InternalResourceApi::class)

package asc_app.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/asc_app.composeapp.generated.resources/"

internal val Res.font.pitagon_sans_text_400: FontResource by lazy {
      FontResource("font:pitagon_sans_text_400", setOf(
        ResourceItem(setOf(), "${MD}font/pitagon_sans_text_400.ttf", -1, -1),
      ))
    }

internal val Res.font.pitagon_sans_text_500: FontResource by lazy {
      FontResource("font:pitagon_sans_text_500", setOf(
        ResourceItem(setOf(), "${MD}font/pitagon_sans_text_500.ttf", -1, -1),
      ))
    }

internal val Res.font.pitagon_sans_text_600: FontResource by lazy {
      FontResource("font:pitagon_sans_text_600", setOf(
        ResourceItem(setOf(), "${MD}font/pitagon_sans_text_600.ttf", -1, -1),
      ))
    }

internal val Res.font.sofia_sans_semi_condensed_500: FontResource by lazy {
      FontResource("font:sofia_sans_semi_condensed_500", setOf(
        ResourceItem(setOf(), "${MD}font/sofia_sans_semi_condensed_500.ttf", -1, -1),
      ))
    }

internal val Res.font.sofia_sans_semi_condensed_600: FontResource by lazy {
      FontResource("font:sofia_sans_semi_condensed_600", setOf(
        ResourceItem(setOf(), "${MD}font/sofia_sans_semi_condensed_600.ttf", -1, -1),
      ))
    }

internal val Res.font.sofia_sans_semi_condensed_700: FontResource by lazy {
      FontResource("font:sofia_sans_semi_condensed_700", setOf(
        ResourceItem(setOf(), "${MD}font/sofia_sans_semi_condensed_700.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("pitagon_sans_text_400", Res.font.pitagon_sans_text_400)
  map.put("pitagon_sans_text_500", Res.font.pitagon_sans_text_500)
  map.put("pitagon_sans_text_600", Res.font.pitagon_sans_text_600)
  map.put("sofia_sans_semi_condensed_500", Res.font.sofia_sans_semi_condensed_500)
  map.put("sofia_sans_semi_condensed_600", Res.font.sofia_sans_semi_condensed_600)
  map.put("sofia_sans_semi_condensed_700", Res.font.sofia_sans_semi_condensed_700)
}
